import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import Lightbox from '../components/Lightbox';

// ── Engagement ──
import en01 from '../imagesForCategory/Engagement/En 01.jpg';
import en02 from '../imagesForCategory/Engagement/En 02.jpg';
import en03 from '../imagesForCategory/Engagement/En 03.jpg';
import en04 from '../imagesForCategory/Engagement/En 04.jpg';
import en05 from '../imagesForCategory/Engagement/En 05.jpg';
import en06 from '../imagesForCategory/Engagement/En 06.jpg';
import en07 from '../imagesForCategory/Engagement/En 07.jpg';
import en08 from '../imagesForCategory/Engagement/En 08.jpg';

// ── Pre Wedding ──
import prew01 from '../imagesForCategory/Prewedding/Prew 01.jpg';
import prew02 from '../imagesForCategory/Prewedding/Prew 02.jpg';
import prew03 from '../imagesForCategory/Prewedding/Prew 03.jpg';
import prew04 from '../imagesForCategory/Prewedding/Prew 04.jpg';
import prew05 from '../imagesForCategory/Prewedding/Prew 05.jpg';
import prew06 from '../imagesForCategory/Prewedding/Prew 06.jpg';
import prew07 from '../imagesForCategory/Prewedding/Prew 07.jpg';
import prew08 from '../imagesForCategory/Prewedding/Prew 08.jpg';

// ── Haldi ──
import ha01 from '../imagesForCategory/Haldi/Ha 01.jpg';
import ha02 from '../imagesForCategory/Haldi/Ha 02.jpg';
import ha03 from '../imagesForCategory/Haldi/Ha 03.jpg';
import ha04 from '../imagesForCategory/Haldi/Ha 04.jpg';
import ha05 from '../imagesForCategory/Haldi/Ha 05.jpg';
import ha06 from '../imagesForCategory/Haldi/Ha 06.jpg';
import ha07 from '../imagesForCategory/Haldi/Ha 07.jpg';
import ha08 from '../imagesForCategory/Haldi/Ha 08.jpg';

// ── Sangeet ──
import sa01 from '../imagesForCategory/Sangeet/Sa 01.jpg';
import sa02 from '../imagesForCategory/Sangeet/Sa 02.jpg';
import sa03 from '../imagesForCategory/Sangeet/Sa 03.jpg';

// ── Mehendi ──
import me01 from '../imagesForCategory/Mehendi/Me 01.jpg';
import me02 from '../imagesForCategory/Mehendi/Me 02.jpg';
import me03 from '../imagesForCategory/Mehendi/Me 03.jpg';
import me04 from '../imagesForCategory/Mehendi/Me 04.jpg';
import me05 from '../imagesForCategory/Mehendi/Me 05.jpg';

// ── Groom ──
import gr01 from '../imagesForCategory/Bride & groom/Gr 01.jpg';
import gr02 from '../imagesForCategory/Bride & groom/Gr 02.jpg';
import gr03 from '../imagesForCategory/Bride & groom/Gr 03.jpg';

// ── Bride ──
import br01 from '../imagesForCategory/Bride & groom/Br 01.jpg';
import br02 from '../imagesForCategory/Bride & groom/Br 02.jpg';
import br03 from '../imagesForCategory/Bride & groom/Br 03.jpg';
import br04 from '../imagesForCategory/Bride & groom/Br 04.jpg';
import br05 from '../imagesForCategory/Bride & groom/Br 05.jpg';
import br06 from '../imagesForCategory/Bride & groom/Br 06.jpg';
import br07 from '../imagesForCategory/Bride & groom/Br 07.jpg';
import br08 from '../imagesForCategory/Bride & groom/Br 08.jpg';

// ── Wedding ──
import wed01 from '../imagesForCategory/Wedding/Wed 01.jpg';
import wed02 from '../imagesForCategory/Wedding/Wed 02.jpg';
import wed03 from '../imagesForCategory/Wedding/Wed 03.jpg';
import wed04 from '../imagesForCategory/Wedding/Wed 04.jpg';
import wed05 from '../imagesForCategory/Wedding/Wed 05.jpg';
import wed06 from '../imagesForCategory/Wedding/Wed 06.jpg';
import wed07 from '../imagesForCategory/Wedding/Wed 07.jpg';
import wed08 from '../imagesForCategory/Wedding/Wed 08.jpg';

// ── Reception ──
import re01 from '../imagesForCategory/Reception/Re 01.jpg';
import re02 from '../imagesForCategory/Reception/Re 02.jpg';
import re03 from '../imagesForCategory/Reception/Re 03.jpg';
import re04 from '../imagesForCategory/Reception/Re 04.jpg';
import re05 from '../imagesForCategory/Reception/Re 05.jpg';
import re06 from '../imagesForCategory/Reception/Re 06.jpg';
import re07 from '../imagesForCategory/Reception/Re 07.jpg';
import re08 from '../imagesForCategory/Reception/Re 08.jpg';
import re09 from '../imagesForCategory/Reception/Re 09.jpg';

const categories = [
  {
    id: 'engagement',
    title: 'Engagement',
    subtitle: 'The Promise of Forever',
    description: 'The engagement ceremony marks the beautiful beginning of a lifelong journey together. We capture the spark in your eyes, the warmth of family blessings, and the joy of saying "yes" — preserving every ring exchange, every embrace, and every heartfelt smile.',
    images: [en01, en02, en03, en04, en05, en06, en07, en08],
  },
  {
    id: 'pre-wedding',
    title: 'Pre Wedding',
    subtitle: 'Your Love Story, Beautifully Told',
    description: 'We believe every love story deserves to be told in a unique and artistic way. Our pre-wedding shoots capture real emotions, natural chemistry, and unforgettable moments between couples. With different lighting techniques — from soft natural light to dramatic cinematic setups — we bring depth, mood, and character to your story.',
    images: [prew01, prew02, prew03, prew04, prew05, prew06, prew07, prew08],
  },
  {
    id: 'haldi',
    title: 'Haldi',
    subtitle: 'Celebrating Colors, Laughter & Love',
    description: 'The Haldi ceremony is one of the most joyful and vibrant moments of an Indian wedding. Filled with turmeric hues, playful rituals, heartfelt blessings, and infectious laughter, it deserves to be captured in its purest and most beautiful form.',
    images: [ha01, ha02, ha03, ha04, ha05, ha06, ha07, ha08],
  },
  {
    id: 'sangeet',
    title: 'Sangeet',
    subtitle: 'Dance, Music & Celebrations',
    description: 'The Sangeet night comes alive with music, dance, and pure celebration. Our team captures the energy of performances, the joy of family dances, candid laughter, and the electric atmosphere.',
    images: [sa01, sa02, sa03],
  },
  {
    id: 'mehendi',
    title: 'Mehendi',
    subtitle: 'Art, Tradition & Elegance',
    description: 'The Mehendi ceremony is a celebration of art, tradition, and feminine grace. From intricate henna designs to colorful outfits and joyful gatherings, we document the beauty of this cherished pre-wedding ritual.',
    images: [me01, me02, me03, me04, me05],
  },
  {
    id: 'groom',
    title: 'Groom',
    subtitle: 'The Confident Charm',
    description: 'From getting ready moments to the confident charm of the groom, we capture every detail — the anticipation, the style, the brotherhood, and those quiet moments before the big celebration begins.',
    images: [gr01, gr02, gr03],
  },
  {
    id: 'bride',
    title: 'Bride',
    subtitle: 'Grace, Beauty & Emotion',
    description: 'The bridal preparations are deeply emotional moments — where traditions, emotions, style, and anticipation come together. From graceful preparations to stunning portraits, we capture every detail beautifully.',
    images: [br01, br02, br03, br04, br05, br06, br07, br08],
  },
  {
    id: 'wedding-ceremony',
    title: 'Wedding',
    subtitle: 'Once in a Lifetime',
    description: 'Your wedding day is filled with once-in-a-lifetime moments. From emotional rituals and joyful celebrations to quiet, intimate moments — we document your wedding just as it unfolds, real, heartfelt, and timeless.',
    images: [wed01, wed02, wed03, wed04, wed05, wed06, wed07, wed08],
  },
  {
    id: 'reception',
    title: 'Reception',
    subtitle: 'The Grand Celebration',
    description: 'The wedding reception is where the couple is celebrated by all. From grand entries and first dances to heartfelt toasts and joyous celebrations, we capture the elegance, glamour, and emotion of your reception night.',
    images: [re01, re02, re03, re04, re05, re06, re07, re08, re09],
  },
];

// ─────────────────────────────────────────
// Image grid layout component
// ─────────────────────────────────────────
function ImageGrid({ images, title, catIdx, onOpen }) {
  if (images.length <= 3) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 stagger">
        {images.map((img, i) => (
          <div key={i} className="album-card scale-up aspect-[3/4]" onClick={() => onOpen(catIdx, i)}>
            <img src={img} alt={`${title} ${i + 1}`} loading="lazy" />
            <div className="overlay">
              <span className="text-cream text-xs font-montserrat tracking-[0.1em] uppercase">{title}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (images.length <= 5) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 stagger">
        {images.map((img, i) => (
          <div
            key={i}
            className={`album-card scale-up ${i === 0 ? 'md:col-span-2 md:row-span-2' : 'aspect-square'}`}
            onClick={() => onOpen(catIdx, i)}
          >
            <img src={img} alt={`${title} ${i + 1}`} loading="lazy" />
            <div className="overlay">
              <span className="text-cream text-xs font-montserrat tracking-[0.1em] uppercase">{title}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Large gallery — featured hero + grid
  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-12 gap-4">
        {/* Hero image */}
        <div className="md:col-span-7 album-card scale-up aspect-[4/3] md:aspect-auto md:min-h-[480px]" onClick={() => onOpen(catIdx, 0)}>
          <img src={images[0]} alt={`${title} featured`} loading="lazy" />
          <div className="overlay">
            <div>
              <span className="text-cream text-xs font-montserrat tracking-[0.1em] uppercase block mb-1">{title}</span>
              <span className="text-cream/50 text-[10px] font-montserrat">1 of {images.length}</span>
            </div>
          </div>
        </div>
        {/* Side grid */}
        <div className="md:col-span-5 grid grid-cols-2 gap-4">
          {images.slice(1, 5).map((img, i) => (
            <div key={i} className="album-card scale-up aspect-square" onClick={() => onOpen(catIdx, i + 1)}>
              <img src={img} alt={`${title} ${i + 2}`} loading="lazy" />
              <div className="overlay">
                <span className="text-cream/70 text-[10px] font-montserrat">{i + 2}/{images.length}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom row */}
      {images.length > 5 && (
        <div className="grid grid-cols-3 gap-4 stagger">
          {images.slice(5).map((img, i) => (
            <div key={i} className="album-card scale-up aspect-[4/3]" onClick={() => onOpen(catIdx, i + 5)}>
              <img src={img} alt={`${title} ${i + 6}`} loading="lazy" />
              <div className="overlay">
                <span className="text-cream/70 text-[10px] font-montserrat">{i + 6}/{images.length}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────
// Main Wedding Page
// ─────────────────────────────────────────
export default function Wedding() {
  useScrollAnimation();
  const [activeCategory, setActiveCategory] = useState('engagement');
  const [lightboxData, setLightboxData] = useState({ catIdx: null, imgIdx: null });
  const stickyRef = useRef(null);
  const isScrollingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const sectionRefsMap = useRef({});

  // Category IDs for lookup
  const categoryIds = useMemo(() => categories.map((c) => c.id), []);

  // ── Active section tracking ──
  // Instead of IntersectionObserver (which fires for multiple sections),
  // we use a scroll listener that finds the topmost section near the viewport top
  useEffect(() => {
    let ticking = false;

    const updateActive = () => {
      // Don't update during programmatic scroll
      if (isScrollingRef.current) return;

      const stickyHeight = stickyRef.current ? stickyRef.current.offsetHeight : 50;
      const headerHeight = 70;
      const offset = stickyHeight + headerHeight + 20;

      let bestId = categoryIds[0];
      let bestDistance = Infinity;

      for (const id of categoryIds) {
        const el = sectionRefsMap.current[id] || document.getElementById(id);
        if (!el) continue;
        sectionRefsMap.current[id] = el;

        const rect = el.getBoundingClientRect();
        // Distance from the section top to our "active line" (just below sticky nav)
        const distance = Math.abs(rect.top - offset);

        // Only consider sections that have scrolled up to or past the offset line
        if (rect.top <= offset + 100 && distance < bestDistance) {
          bestDistance = distance;
          bestId = id;
        }
      }

      setActiveCategory((prev) => (prev !== bestId ? bestId : prev));
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateActive);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    // Initial check
    requestAnimationFrame(updateActive);

    return () => window.removeEventListener('scroll', onScroll);
  }, [categoryIds]);

  // ── Scroll to section (with active state override) ──
  const scrollToSection = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Immediately set active — don't wait for scroll observer
    setActiveCategory(id);

    // Block the scroll observer from overriding during animated scroll
    isScrollingRef.current = true;
    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);

    const stickyHeight = stickyRef.current ? stickyRef.current.offsetHeight : 50;
    const headerHeight = 70;
    const top = el.getBoundingClientRect().top + window.scrollY - stickyHeight - headerHeight;

    window.scrollTo({ top, behavior: 'smooth' });

    // Re-enable scroll observer after animation completes
    scrollTimeoutRef.current = setTimeout(() => {
      isScrollingRef.current = false;
    }, 900);
  }, []);

  // ── Auto-scroll active pill into view ──
  useEffect(() => {
    const pill = document.querySelector(`.cat-pill.active`);
    if (pill) {
      pill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [activeCategory]);

  // ── Lightbox ──
  const openLightbox = useCallback((catIdx, imgIdx) => {
    setLightboxData({ catIdx, imgIdx });
  }, []);
  const closeLightbox = useCallback(() => {
    setLightboxData({ catIdx: null, imgIdx: null });
  }, []);

  const currentCatImages = lightboxData.catIdx !== null ? categories[lightboxData.catIdx].images : [];

  return (
    <main>
      {/* ═══ STICKY CATEGORY NAV ═══ */}
      <div
        ref={stickyRef}
        className="sticky top-[60px] lg:top-[64px] z-50 bg-charcoal/98 backdrop-blur-lg border-y border-gold/8"
      >
        <div className="max-w-7xl mx-auto px-2 overflow-x-auto scrollbar-hide">
          <div className="flex items-center gap-0.5 py-2 min-w-max mx-auto w-fit">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => scrollToSection(cat.id)}
                className={`cat-pill ${activeCategory === cat.id ? 'active' : ''}`}
              >
                {cat.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ═══ CATEGORY SECTIONS ═══ */}
      {categories.map((cat, catIdx) => (
        <section
          key={cat.id}
          id={cat.id}
          className={`py-20 md:py-28 ${catIdx % 2 === 0 ? 'bg-charcoal' : 'bg-charcoal-light'}`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section header — alternate alignment */}
            <div className={`mb-12 md:mb-16 max-w-3xl ${catIdx % 2 === 0 ? 'mx-auto text-center' : ''}`}>
              <div className="fade-up">
                <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-montserrat mb-2">
                  {cat.subtitle}
                </p>
                <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-cream mb-4">
                  {cat.title}
                </h2>
                <div className={`mb-6 ${catIdx % 2 === 0 ? 'gold-line' : 'gold-line-left'}`} />
                <p className="text-cream/55 text-sm md:text-base leading-[1.8] font-light">
                  {cat.description}
                </p>
              </div>
            </div>

            {/* Image Grid */}
            <ImageGrid
              images={cat.images}
              title={cat.title}
              catIdx={catIdx}
              onOpen={openLightbox}
            />
          </div>

          {/* Divider between sections */}
          {catIdx < categories.length - 1 && (
            <div className="section-divider mt-20 md:mt-28" />
          )}
        </section>
      ))}

      {/* ═══ CTA ═══ */}
      <section
        className="parallax-section py-28 md:py-36"
        style={{ backgroundImage: `url(${wed05})` }}
      >
        <div className="max-w-4xl mx-auto px-4 text-center fade-up">
          <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Ready to Begin?</p>
          <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
            Book Your <span className="italic text-gold">Wedding Coverage</span>
          </h2>
          <div className="gold-line mb-8" />
          <p className="text-cream/60 text-base md:text-lg mb-12 max-w-2xl mx-auto font-light">
            Let us preserve your wedding memories in the most beautiful way, so you can relive your special day again and again.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+919703377033" className="btn-gold">Call +91-9703377033</a>
            <a href="https://wa.me/919703377033" target="_blank" rel="noopener noreferrer" className="btn-outline">WhatsApp Us</a>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxData.imgIdx !== null && (
        <Lightbox
          image={currentCatImages[lightboxData.imgIdx]}
          onClose={closeLightbox}
          onPrev={lightboxData.imgIdx > 0 ? () => setLightboxData((d) => ({ ...d, imgIdx: d.imgIdx - 1 })) : null}
          onNext={lightboxData.imgIdx < currentCatImages.length - 1 ? () => setLightboxData((d) => ({ ...d, imgIdx: d.imgIdx + 1 })) : null}
        />
      )}
    </main>
  );
}
